import React, { useState, useEffect } from "react"
import { MetafieldsIcon } from "@shopify/polaris-icons";
import {
    Icon, Popover, ActionList, TextField
} from "@shopify/polaris";
import './index.css';

const FreeTagInputTraceless = (props) => {
    const {
        id,
        tagInputDataTraceless,
        isShowSelectPop,
        actionList,
        tagActive,
        changeSelectPop,
        defaultTag,
        hiddenAddBtn,
    } = props;

    const [tagValue, setTagValue] = useState("");

    // 打开选择项
    const openSelectPopver = (id) => {
        changeSelectPop(id);
    }

    // 监听改变
    const onTagChange = (val) => {
        tagInputDataTraceless(val);
    }

    useEffect(() => {
        setTagValue(defaultTag);
    }, [defaultTag])

    return (
        <div className={`free_tag_input_traceless ${Boolean(tagActive) && (tagActive.length > 0 && tagActive.includes(id)) ? 'tagActive' : ''}`} id={`${id}_Input`}>
            <TextField
                value={tagValue}
                onChange={onTagChange}
                autoComplete="off"
                error={(Boolean(tagActive) && (tagActive.length > 0 && tagActive.includes(id))) ? "The input cannot be empty!" : null}
            />
            {
                !Boolean(hiddenAddBtn) ? <div className={`free_suffix`}>
                    <Popover
                        active={isShowSelectPop}
                        activator={
                            <div className="suffix_meta" onClick={() => openSelectPopver(id)}>
                                <Icon source={MetafieldsIcon} color="base" />
                            </div>
                        }
                        autofocusTarget="first-node"
                        onClose={() => openSelectPopver(id)}
                    >
                        <Popover.Pane>
                            <ActionList
                                actionRole="menuitem"
                                items={actionList}
                            />
                        </Popover.Pane>
                    </Popover>
                </div> : null
            }
        </div>
    );
}

export default FreeTagInputTraceless;
